(function () {
  'use strict';

  class PlanoAnualBlock {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      this.variantId = el.dataset.variantId;
      this.productId = el.dataset.productId;

      this.radio = el.querySelector('[data-plano-radio]');

      this.freqWrap = el.querySelector('[data-plano-select]');
      this.freqTrigger = el.querySelector('[data-plano-select-trigger]');
      this.freqOptions = el.querySelector('[data-plano-select-options]');
      this.freqOptionBtns = el.querySelectorAll('[data-plano-frequency-option]');
      this.freqValueEl = el.querySelector('[data-plano-frequency-value]');

      this.flavorsWrap = el.querySelector('[data-plano-flavors]');
      this.flavorsTrigger = el.querySelector('[data-plano-flavors-trigger]');
      this.flavorsPanel = el.querySelector('[data-plano-flavors-panel]');
      this.flavors = el.querySelectorAll('[data-plano-flavor]');
      this.counterEl = el.querySelector('[data-plano-counter]');
      this.counterCurrent = el.querySelector('[data-plano-current]');
      this.counterMax = el.querySelector('[data-plano-max]');

      this.errorEl = el.querySelector('[data-plano-error]');

      this.maxFlavors = 0;
      this.frequencyLabel = '';
      this.quantities = new Map();

      this.init();
    }

    init() {
      this.flavors.forEach((flavor) => {
        const title = flavor.dataset.flavorTitle;
        this.quantities.set(title, 0);
      });

      if (this.freqOptionBtns.length > 0) {
        const defaultIdx = parseInt(this.el.dataset.defaultFrequencyIndex || '0', 10);
        const idx = Math.min(Math.max(defaultIdx, 0), this.freqOptionBtns.length - 1);
        this.selectFrequency(this.freqOptionBtns[idx], false);
      }

      this.freqTrigger?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleFrequency();
      });

      this.freqOptionBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectFrequency(btn, true);
        });
      });

      this.flavorsTrigger?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleFlavors();
      });

      this.flavors.forEach((flavor) => {
        const minusBtn = flavor.querySelector('[data-plano-qty-minus]');
        const plusBtn = flavor.querySelector('[data-plano-qty-plus]');
        const valueEl = flavor.querySelector('[data-plano-qty-value]');
        const title = flavor.dataset.flavorTitle;

        minusBtn?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.changeQuantity(title, -1, valueEl);
        });
        plusBtn?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.changeQuantity(title, 1, valueEl);
        });
      });

      document.addEventListener('click', (e) => {
        if (this.freqWrap && !this.freqWrap.contains(e.target)) {
          this.closeFrequency();
        }
      });

      this.attachFormHijack();
      this.attachClickGuard();
      this.setupKachingSync();
      this.updateUI();
    }

    isActive() {
      return this.radio ? this.radio.checked : true;
    }

    setupKachingSync() {
      if (!this.radio) return;

      const KACHING_RADIO_SELECTOR = 'input[name^="kaching-bundles-deal-"]';

      this._syncingFromKaching = false;

      this.radio.addEventListener('change', () => {
        if (this._syncingFromKaching) return;
        if (this.radio.checked) {
          this.deselectKaching(KACHING_RADIO_SELECTOR);
        }
      });

      document.addEventListener(
        'change',
        (e) => {
          const target = e.target;
          if (
            !target ||
            typeof target.matches !== 'function' ||
            !target.matches(KACHING_RADIO_SELECTOR)
          ) {
            return;
          }
          if (target.checked && this.radio.checked) {
            this._syncingFromKaching = true;
            this.radio.checked = false;
            this.hideError();
            this._syncingFromKaching = false;
          }
        },
        true
      );

      document.addEventListener(
        'click',
        (e) => {
          if (!this.radio.checked) return;
          if (!e.target || typeof e.target.closest !== 'function') return;
          const bar = e.target.closest('.kaching-bundles__bar');
          if (!bar) return;
          if (e.target.closest('[data-plano-anual]')) return;
          this._syncingFromKaching = true;
          this.radio.checked = false;
          this.hideError();
          this._syncingFromKaching = false;
        },
        true
      );
    }

    deselectKaching(selector) {
      document.querySelectorAll(selector).forEach((input) => {
        if (!input.checked) return;
        input.checked = false;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document
        .querySelectorAll('.kaching-bundles__bar--selected')
        .forEach((bar) => bar.classList.remove('kaching-bundles__bar--selected'));
    }

    toggleFrequency() {
      if (this.freqOptions.hasAttribute('hidden')) {
        this.openFrequency();
      } else {
        this.closeFrequency();
      }
    }

    openFrequency() {
      this.freqOptions.removeAttribute('hidden');
      this.freqTrigger?.setAttribute('aria-expanded', 'true');
    }

    closeFrequency() {
      this.freqOptions?.setAttribute('hidden', '');
      this.freqTrigger?.setAttribute('aria-expanded', 'false');
    }

    selectFrequency(btn, resetIfShrinking) {
      const max = parseInt(btn.dataset.max, 10) || 0;
      const label = btn.dataset.label || btn.textContent.trim();

      this.maxFlavors = max;
      this.frequencyLabel = label;
      if (this.freqValueEl) this.freqValueEl.textContent = label;

      this.freqOptionBtns.forEach((b) => {
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });

      this.closeFrequency();

      if (resetIfShrinking && this.radio && !this.radio.checked) {
        this.radio.checked = true;
        this.radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (resetIfShrinking && this.getTotalCount() > this.maxFlavors) {
        this.flavors.forEach((flavor) => {
          const valueEl = flavor.querySelector('[data-plano-qty-value]');
          const title = flavor.dataset.flavorTitle;
          this.quantities.set(title, 0);
          if (valueEl) valueEl.textContent = '0';
        });
      }

      this.updateUI();
    }

    toggleFlavors() {
      const open = this.flavorsWrap.getAttribute('data-open') === 'true';
      if (open) {
        this.closeFlavors();
      } else {
        this.openFlavors();
      }
    }

    openFlavors() {
      this.flavorsWrap.setAttribute('data-open', 'true');
      this.flavorsPanel.removeAttribute('hidden');
      this.flavorsTrigger?.setAttribute('aria-expanded', 'true');
    }

    closeFlavors() {
      this.flavorsWrap.setAttribute('data-open', 'false');
      this.flavorsPanel.setAttribute('hidden', '');
      this.flavorsTrigger?.setAttribute('aria-expanded', 'false');
    }

    changeQuantity(title, delta, valueEl) {
      const current = this.quantities.get(title) || 0;
      const total = this.getTotalCount();

      if (delta > 0 && total >= this.maxFlavors) return;

      let next = current + delta;
      if (next < 0) next = 0;
      if (next === current) return;

      this.quantities.set(title, next);
      if (valueEl) valueEl.textContent = String(next);

      if (delta > 0 && this.radio && !this.radio.checked) {
        this.radio.checked = true;
        this.radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (delta > 0) {
        this.showToast(title, next);
      }

      this.hideError();
      this.updateUI();
    }

    escapeHTML(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    getFlavorTheme(title) {
      const lower = (title || '').toLowerCase();
      const map = [
        ['blueberry', { emoji: '🫐', theme: 'blueberry' }],
        ['mirtilo', { emoji: '🫐', theme: 'blueberry' }],
        ['açaí', { emoji: '🫐', theme: 'blueberry' }],
        ['acai', { emoji: '🫐', theme: 'blueberry' }],
        ['morango', { emoji: '🍓', theme: 'strawberry' }],
        ['frutas vermelhas', { emoji: '🍓', theme: 'strawberry' }],
        ['frutas-vermelhas', { emoji: '🍓', theme: 'strawberry' }],
        ['cereja', { emoji: '🍒', theme: 'cherry' }],
        ['lichia', { emoji: '🍒', theme: 'cherry' }],
        ['coco', { emoji: '🥥', theme: 'coconut' }],
        ['pitaya', { emoji: '🐉', theme: 'pitaya' }],
        ['limonada', { emoji: '🍋', theme: 'lemon' }],
        ['limão', { emoji: '🍋', theme: 'lemon' }],
        ['limao', { emoji: '🍋', theme: 'lemon' }],
        ['laranja', { emoji: '🍊', theme: 'orange' }],
        ['tangerina', { emoji: '🍊', theme: 'orange' }],
        ['citrus', { emoji: '🍊', theme: 'orange' }],
        ['maracujá', { emoji: '💛', theme: 'passion' }],
        ['maracuja', { emoji: '💛', theme: 'passion' }],
        ['kiwi', { emoji: '🥝', theme: 'kiwi' }],
        ['manga', { emoji: '🥭', theme: 'mango' }],
        ['abacaxi', { emoji: '🍍', theme: 'pineapple' }],
        ['banana', { emoji: '🍌', theme: 'banana' }],
        ['uva', { emoji: '🍇', theme: 'grape' }],
        ['maçã', { emoji: '🍎', theme: 'apple' }],
        ['maca', { emoji: '🍎', theme: 'apple' }],
        ['pêssego', { emoji: '🍑', theme: 'peach' }],
        ['pessego', { emoji: '🍑', theme: 'peach' }],
        ['melancia', { emoji: '🍉', theme: 'watermelon' }],
        ['gengibre', { emoji: '🫚', theme: 'ginger' }],
      ];
      for (const [key, data] of map) {
        if (lower.includes(key)) return data;
      }
      return { emoji: '🎉', theme: 'default' };
    }

    showToast(title, count) {
      let container = document.querySelector('.plano-anual-toast-container');
      if (!container) {
        container = document.createElement('div');
        container.className = 'plano-anual-toast-container';
        document.body.appendChild(container);
      }

      container.querySelectorAll('.plano-anual-toast').forEach((t) => t.remove());

      const { emoji, theme } = this.getFlavorTheme(title);
      const safeCount = Math.max(1, parseInt(count, 10) || 1);

      const toast = document.createElement('div');
      toast.className = 'plano-anual-toast plano-anual-toast--' + theme;
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="plano-anual-toast__icon" aria-hidden="true">' + emoji + '</span>' +
        '<span class="plano-anual-toast__text">' +
          '<strong>' + this.escapeHTML(title) + '</strong>' +
          '<small>Sabor adicionado ' + safeCount + 'x</small>' +
        '</span>';
      container.appendChild(toast);

      toast.offsetHeight;
      requestAnimationFrame(() => toast.classList.add('is-visible'));

      const remove = () => {
        toast.classList.add('is-leaving');
        toast.classList.remove('is-visible');
        setTimeout(() => toast.remove(), 400);
      };

      const hideTimer = setTimeout(remove, 2500);

      toast.addEventListener('click', () => {
        clearTimeout(hideTimer);
        remove();
      });
    }

    getTotalCount() {
      let total = 0;
      this.quantities.forEach((qty) => {
        total += qty;
      });
      return total;
    }

    updateUI() {
      const total = this.getTotalCount();

      if (this.counterCurrent) this.counterCurrent.textContent = String(total);
      if (this.counterMax) this.counterMax.textContent = String(this.maxFlavors);

      const isFull = total >= this.maxFlavors && this.maxFlavors > 0;
      if (this.counterEl) this.counterEl.classList.toggle('is-full', isFull);

      this.flavors.forEach((flavor) => {
        const plusBtn = flavor.querySelector('[data-plano-qty-plus]');
        if (plusBtn) plusBtn.disabled = isFull;
      });
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.classList.add('is-visible');
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.classList.remove('is-visible');
    }

    hasKachingDealSelected() {
      return !!document.querySelector('input[name^="kaching-bundles-deal-"]:checked');
    }

    validateSelection() {
      if (!this.isActive()) {
        if (this.hasKachingDealSelected()) {
          return { valid: true };
        }
        return {
          valid: false,
          message: 'Selecione uma opção de compra para continuar.',
        };
      }

      if (this.maxFlavors === 0 || !this.frequencyLabel) {
        return {
          valid: false,
          message: 'Selecione a frequência de entrega antes de continuar.',
          openFrequency: true,
        };
      }

      if (this.flavors.length > 0) {
        const total = this.getTotalCount();
        if (total < this.maxFlavors) {
          return {
            valid: false,
            message: `Selecione ${this.maxFlavors} sabor${this.maxFlavors > 1 ? 'es' : ''} antes de continuar (${total}/${this.maxFlavors}).`,
            openFlavors: true,
          };
        }
      }

      return { valid: true };
    }

    handleInvalidSelection(result) {
      if (result.openFrequency) this.openFrequency();
      if (result.openFlavors) this.openFlavors();
      this.showError(result.message);
      if (this.errorEl && typeof this.errorEl.scrollIntoView === 'function') {
        this.errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    buildProperties() {
      const flavorLines = [];
      this.quantities.forEach((qty, title) => {
        if (qty > 0) flavorLines.push(`${qty} x ${title}`);
      });
      return {
        'Frequência de entrega': this.frequencyLabel,
        Sabores: flavorLines.join('\n'),
        '_Aceitou os termos': 'Sim',
      };
    }

    attachFormHijack() {
      document.addEventListener(
        'submit',
        (e) => {
          const form = e.target;
          if (
            !form ||
            typeof form.matches !== 'function' ||
            !form.matches('form[data-type="add-to-cart-form"]')
          ) {
            return;
          }
          const result = this.validateSelection();
          if (!result.valid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.handleInvalidSelection(result);
            return;
          }

          if (!this.isActive()) return;

          e.preventDefault();
          e.stopImmediatePropagation();
          this.addToCart(form);
        },
        true
      );
    }

    attachClickGuard() {
      document.addEventListener(
        'click',
        (e) => {
          if (!e.target || typeof e.target.closest !== 'function') return;

          const buyTrigger = e.target.closest(
            'form[data-type="add-to-cart-form"] [type="submit"], form[data-type="add-to-cart-form"] button[name="add"], .shopify-payment-button'
          );
          if (!buyTrigger) return;

          const result = this.validateSelection();
          if (result.valid) return;

          e.preventDefault();
          e.stopImmediatePropagation();
          this.handleInvalidSelection(result);
        },
        true
      );
    }

    async addToCart(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      submitBtn?.setAttribute('aria-disabled', 'true');
      submitBtn?.classList.add('loading');
      const loadingSpinner = submitBtn?.querySelector('.loading__spinner');
      loadingSpinner?.classList.remove('hidden');

      const properties = this.buildProperties();

      try {
        const sections = this.getSectionsToFetch();
        const body = {
          items: [
            {
              id: parseInt(this.variantId, 10),
              quantity: 1,
              properties,
            },
          ],
          sections,
          sections_url: window.location.pathname,
        };

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          this.showError(errData.description || 'Erro ao adicionar ao carrinho.');
          return;
        }

        const data = await response.json();

        const cartDrawer = document.querySelector('cart-drawer');
        if (typeof window.refreshCartDrawer === 'function') {
          window.refreshCartDrawer();
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (err) {
        console.error('plano-anual addToCart error:', err);
        this.showError('Erro ao adicionar ao carrinho.');
      } finally {
        submitBtn?.removeAttribute('aria-disabled');
        submitBtn?.classList.remove('loading');
        loadingSpinner?.classList.add('hidden');
      }
    }

    getSectionsToFetch() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        try {
          return cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
        } catch (_) {
          return 'cart-drawer,cart-icon-bubble';
        }
      }
      return 'cart-drawer,cart-icon-bubble';
    }
  }

  function initAll() {
    document.querySelectorAll('[data-plano-anual]').forEach((el) => {
      if (el.dataset.planoInitialized === 'true') return;
      el.dataset.planoInitialized = 'true';
      new PlanoAnualBlock(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
